module.exports = __webpack_public_path__ + "img/upload_wall_2.155a3b75.webp";